import * as React from 'react';
import { Row, Col, Icon, Button, message, Tooltip, Modal, Form, Tag,Dropdown , Menu } from 'antd';
import { MOBILE_BREAK_POINT } from 'src/globals';
import injectSheet from 'react-jss';
import QuoteConfirmationModal from '../Modals/QuoteConfirmationModal';
import QuoteRejectionModal from '../Modals/QuoteRejectionModal';
import moment from 'moment';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { confirmBid, declineBid, deleteBidForShipper, getExchangeRate } from 'src/api/inquiry';
import { resetFilters, applyFilter } from 'src/actions/inquiryShipperActionsBids';
import { bindActionCreators } from 'redux';
import ViewBreakdown from 'src/components/pages/Enquiry/Modals/ViewBreakdown';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import DeleteBidConfirmationModal from '../Modals/DeleteBidConfirmationModal';
import DeleteBidSuccessModal from '../Modals/DeleteBidSuccessModal';
import { bookingShipperRoute } from 'src/routing/utils';
import CommentCount from '../../../common/comments/CommentCount';
import FrieghtPerUnit from '../../../common/FreightPerUnit';
import BidRevisionModal from '../BidRevisionModal';
import {
  BID_ROUTES_CARD_LABELS,
  BookingStats,
  ConnectionType,
  connectionRequestMessage,
  getDomesticCharges,
  getBidTotal,
  hasExistingBookings,
  inquiryOptionsMap,
  InquiryModes,
  InquirySource,
} from '../InquiryUtils';
import ExistingBookingAlertModal from '../Modals/ExistingBookingAlertModal';
import { commonStyles } from 'src/Library/CommonStyles';
import CreateInquiryModal from '../Modals/CreateInquiryModal';
import BookingSuccessProtip from '../Modals/BookingSuccessProtip';
import { fetchKYC } from '../../kycConnections/kycConnections.api';
import FFConnectionRequestKYC from '../../kycConnections/FFConnectionRequestKYC';
import { OrganisationOnboardingStatus } from '../../masters/Masters.Helper';
import { isValidArray, isValidNumber, getDateValue } from 'src/Library/Helper';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import BookingTnCModal from '../../DiscoverRate/BookingTnCModal';
import { getTrailerOrDomesticVehicleList, renderTotalPrice } from './InquiryCommon';
import classNames from 'classnames';
import { DownloadDocument } from 'src/components/common/DownloadDocument';
import AdditionalEmailsForBookingModal from '../Modals/AdditionalEmailsForBookingModal';
import FieldRate from 'src/components/common/form/FieldRate';
import FileViewer from 'src/components/common/FileViewer';
import { formatDateFromObject } from 'src/utils/utils';
import { tokens } from 'src/design-system';
const styles = (theme) => ({
  parentDiv: {
    '& .ant-btn': {
      boxShadow: '0 0 0 rgba(0,0,0,0) !important',
    },
    padding: '16px 16px 10px 24px',
    height: '100%',
    background: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    margin: '4px 24px 4px 6px',
  },
  titleLabel: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    lineHeight: '110%',
  },
  cardHeaderItemsStyle: {
    fontSize: `${tokens.fontSize.small}px`,
    marginBottom: '10px',
    color: '#595959',
  },
  info: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '48%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  dateStyle: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '56%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  cardIcon: {
    margin: '0px 0px 0px 2px',
    fontSize: `${tokens.fontSize.h2}px`,
  },
  cardDeleteIcon: {
    padding: '10px',
  },
  cardEditIcon: {
    padding: '10px',
  },
  viewBreakdownStyle: {
    fontSize: `${tokens.fontSize.caption}px`,
    margin: '5px 0px 0px 0px',
    color: tokens.colors.primary,
  },
  iconToolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  versionHistoryButton: {
    marginLeft: 8,
    color: theme.primaryColor,
    cursor: 'pointer',
  },
  renderVersionContainer: {
    display: 'inline-block',
  },
  btmRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
    gap: '8px',
  },
  btmRowLeftSection: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    minWidth: 0,
  },
  updatedTimeContainer: {
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
  },
  connectionStatus: {
    backgroundColor: '#FFFEE7',
    color: '#666666',
    fontWeight: tokens.fontWeight.semibold,
    padding: '8px 16px',
    fontSize: `${tokens.fontSize.small}px`,
    margin: '0 -16px -10px 0',
    borderRadius: `${tokens.radius.md}px`,
  },
  checkStatus: {
    marginLeft: '12px',
    fontWeight: 'bold',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  confirmBookButtons: {
    ...commonStyles(theme).justifySpaceBetween,
  },
  bookButton: {
    border: tokens.colors.primary,
    fontSize: `${tokens.fontSize.body}px`,
    textShadow: 'none',
    padding: '0 8px',
    marginTop: '14px',
  },
  ffOrgName: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#262626',
    ...commonStyles(theme).ellipses,
    maxWidth: '90%',
  },
  ellipsis: {
    ...commonStyles(theme).ellipses,
  },
  domesticInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    padding: '0px 0px 0px 5px',
  },
  domensticBidInfoRow: {
    marginTop: '16px',
  },
  confirmationReasonButton: {
    borderColor: '#D9D9D9',
    fontSize: tokens.fontSize.caption,
    backgroundColor: '#F5F5F5',
    cursor: 'auto',
    maxWidth: '250px',
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  confirmationReasonIcon: {
    color: '#52C41A',
    marginRight: '4px',
    flexShrink: 0,
  },
  confirmationReasonText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: 1,
  },
});

const info = () => {
  message.success('Your bid has been sent.');
};
class ShipperBidCard extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      isCardLoading: false,
      confirmModalVisible: false,
      rejectModalVisible: false,
      viewBreakDownVisible: false,
      deleteBidModalVisible: false,
      commentVisible: false,
      deleteSuccess: false,
      deletionReason: '',
      isSaving: false,
      revisionModalVisible: false,
      isFFConnectionRequestVisible: false,
      kycData: [],
      kycExists: false,
      isGeneratingBookingData: false,
      isBookingTnCModalVisible: false,
      isExistingBookingAlertVisible: false,
      existingBidBookingStats: undefined as BookingStats | undefined,
      existingInquiryBookingStats: undefined as BookingStats | undefined,
      vehicleViewExpanded: {} as { [bidCardId: string]: string },
      isVehicleDetailsExpanded: false,
      fileViewerVisible: false,
      selectedDocument: null,
    };
  }

  handleConfirm = async (closeInquiry, reason) => {
    const { id: inquiryId } = this.props.inquiryData;
    const { shipperId } = this.props.inquiryData;
    const { id: bidId } = this.props.cardData;
    this.setState({ isCardLoading: true });
    await confirmBid({
      bidIds: [bidId],
      inquiryId,
      shipperId,
      closeInquiry,
      reasonForNonL1BidConfirmation: reason,
    })
      .then((res) => {
        if (res.isSuccess) {
          this.props.resetFilters(inquiryId);
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to confirm the quote? - yes'
          );
        } else {
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to confirm the quote? - yes (Failed)'
          );
          message.error('Unable to handle request');
        }
      })
      .then(() => {
        this.setState({ confirmModalVisible: false });
        this.props.refreshInquiryData();
      });
    this.setState({ isCardLoading: false });
    this.setState({
      confirmModalVisible: false,
      rejectModalVisible: false,
    });
  };

  handleCommentSubmit = () => {
    if (!this.state.deletionReason) {
      message.error('Reason is required');
      this.setState({
        creating: false,
      });
      return;
    }
    this.setState({ commentVisible: false });
  };

  handleDecline = async (deadlineDate) => {
    const { id: inquiryId } = this.props.inquiryData;
    const { shipperId } = this.props.inquiryData;
    const { id: bidId } = this.props.cardData;
    this.setState({ isCardLoading: true });
    const deadline = deadlineDate
      ? {
          dateString: moment(deadlineDate).format('YYYY-MM-DD'),
          time: moment(deadlineDate).format('HH:mm'),
        }
      : undefined;
    await declineBid({ bidId, inquiryId, shipperId, deadline })
      .then((res) => {
        if (res.isSuccess) {
          this.props.resetFilters(inquiryId);
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to decline the quote? - yes'
          );
        } else {
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to decline the quote? - yes (Failed)'
          );
          message.error('Unable to handle request');
        }
      })
      .then(() => {
        this.setState({ rejectModalVisible: false });
        this.props.refreshInquiryData();
      });
    this.setState({ isCardLoading: false });
  };

  renderButton = () => {
    const { permissions: {INQUIRY_CONFIRM_DECLINE_ACTIONS}, cardData } = this.props;
    const { isConfirmationRequiredForNegotiatedBid } = cardData;
    if (
      !INQUIRY_CONFIRM_DECLINE_ACTIONS ||
      this.props.cardData.isDeletedByShipper ||
      isConfirmationRequiredForNegotiatedBid
    )
      return;

    const isDisabled = false; // https://shipsy.atlassian.net/browse/CORE-13127 Keep Book now button/Confirm always visible
    // const isDisabled = this.props.isFirstConfirmed ^ this.props.cardData.isConfirmed;
    return (
      <Button
        type="primary"
        style={{
          height: '36px',
          width: '90px',
          backgroundColor: `${isDisabled ? '#999999' : '#52C41A'}`,
          margin: '14px 0px 0px 0px',
          borderColor: `${isDisabled ? '#999999' : '#52C41A'}`,
          fontSize: `${tokens.fontSize.body}px`,
          cursor: isDisabled ? 'default' : 'pointer',
        }}
        onClick={isDisabled ? undefined : this.showQuoteConfirmationModal}
      >
        Confirm
      </Button>
    );
  };

  renderUpdatedTime = () => {
    const { cardData } = this.props;
    if (!cardData.updatedAt) return null;
    const flag = moment(cardData.updatedAt).format('DD MMM, YYYY | hh:mm A');
    return (
      <div
        style={{
          opacity: 0.7,
          fontSize: '13px',
          fontStyle: 'italic',
          paddingRight: '35px',
        }}
      >
        Updated on: {flag}
      </div>
    );
  };

  showQuoteConfirmationModal = () => {
    this.setState({
      confirmModalVisible: true,
    });
  };

  showQuoteRejectionModal = () => {
    this.setState({
      rejectModalVisible: true,
    });
  };

  quoteConfirmModalHandleCancel = () => {
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'Are you sure, you want to confirm the quote? - no'
    );
    this.setState({
      confirmModalVisible: false,
    });
  };

  quoteRejectModalHandleCancel = () => {
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'Are you sure, you want to decline the quote? - no'
    );
    this.setState({
      rejectModalVisible: false,
    });
  };

  toggleConfirm = (closeOrReopenInquiry, reason = '') => {
    if (this.props.cardData.isConfirmed) {
      this.handleDecline(closeOrReopenInquiry);
    } else {
      closeOrReopenInquiry === 'INQUIRY_CLOSED'
        ? this.handleConfirm(true, reason)
        : this.handleConfirm(false, reason);
    }
  };

  handleViewBreakDown = () => {
    this.setState({ viewBreakDownVisible: true });
  };

  closeViewBreakdown = () => {
    this.setState({ viewBreakDownVisible: false });
  };

  handleOkViewBreakDown = () => {
    this.setState({ viewBreakDownVisible: false });
  };

  handleOnChangeReason = (event) => {
    this.setState({ deletionReason: event.target.value });
  };

  handleDeleteBid = async () => {
    if (!this.state.deletionReason) {
      message.error('Reason is required');
      this.setState({
        creating: false,
      });
      return;
    }
    this.setState({ isCardLoading: true });
    await deleteBidForShipper(this.props.cardData.id, this.state.deletionReason)
      .then((res) => {
        if (res.isSuccess) {
          this.setState({ deleteSuccess: true });
          sendEvent(EventCategories.INQUIRY_BID_CONFIRMATION, 'Delete Bid - Success', 'Shipper');
        } else {
          sendEvent(EventCategories.INQUIRY_BID_CONFIRMATION, 'Delete Bid - Failed', 'Shipper');
          message.error('Unable to delete Bid');
        }
      })
      .then(() => this.setState({ deleteBidModalVisible: false }));
    this.setState({ isCardLoading: false });
  };

  renderBookingTncModal = (): React.ReactElement => {
    const { isBookingTnCModalVisible, bidRankData } = this.state;
    const { cardData } = this.props;
    const { ffCarrier } = cardData;
    return (
      <BookingTnCModal
        isVisible={isBookingTnCModalVisible}
        carrierCode={ffCarrier}
        onAccept={() => {
          this.setState({ isBookingTnCModalVisible: false });
          this.handleBookNow();
        }}
        onDecline={() => this.setState({ isBookingTnCModalVisible: false })}
      />
    );
  };

  handleBookNowButtonClick = () => {
    const { cardData, inquiryBookingStats } = this.props;
    const { bookingStats: bidBookingStats } = cardData;

    if (hasExistingBookings(inquiryBookingStats) || hasExistingBookings(bidBookingStats)) {
      this.setState({
        existingBidBookingStats: bidBookingStats,
        existingInquiryBookingStats: inquiryBookingStats,
        isExistingBookingAlertVisible: true,
      });
      return;
    }

    this.proceedWithBooking();
  };

  proceedWithBooking = () => {
    const { cardData } = this.props;
    const { connectionType, source, isStrategicFF, mode } = cardData;
    if (
      (source === InquirySource.SPOT_SEARCH ||
        source === InquirySource.SPOT_SEARCH_ZERO_RESULTS ||
        connectionType === ConnectionType.SPOT_CONNECTION ||
        isStrategicFF) &&
      mode === 'FCL'
    ) {
      this.setState({ isBookingTnCModalVisible: true });
      return;
    }
    this.handleBookNow();
  };

  handleExistingBookingAlertProceed = () => {
    this.setState({ isExistingBookingAlertVisible: false });
    this.proceedWithBooking();
  };

  renderExistingBookingAlertModal = (): React.ReactElement => {
    const { isExistingBookingAlertVisible, existingBidBookingStats, existingInquiryBookingStats } = this.state;
    return (
      <ExistingBookingAlertModal
        bidBookingStats={existingBidBookingStats}
        inquiryBookingStats={existingInquiryBookingStats}
        isVisible={isExistingBookingAlertVisible}
        onCancel={() => this.setState({ isExistingBookingAlertVisible: false })}
        onProceed={this.handleExistingBookingAlertProceed}
      />
    );
  };

  renderBookNowButton = () => {
    const { permissions: {INQUIRY_ALL_ACTIONS}, classes, cardData } = this.props;
    return (
      <Button
        type="primary"
        size="default"
        disabled={!INQUIRY_ALL_ACTIONS}
        onClick={() => INQUIRY_ALL_ACTIONS ? this.handleBookNowButtonClick() : undefined}
        className={classes.bookButton}
        style={{
          backgroundColor: INQUIRY_ALL_ACTIONS ? tokens.colors.primary : '#D9D9D9',
          pointerEvents: !INQUIRY_ALL_ACTIONS ? 'none' : undefined,
          cursor: !INQUIRY_ALL_ACTIONS ? 'pointer' : undefined,
        }}
      >
        Book Now
      </Button>
    );
  };

  handleOpenCreateBookingModal = () => {
    sendEvent(EventCategories.INQUIRY_BOOKING_SHIPPER, 'Book Now - Clicked', 'Bid List View');
    this.setState({
      createInquiryModalVisible: true,
    });
  };

  handleBookNow = async () => {
    const {
      cardData: { connectionStatus },
    } = this.props;
    if (connectionStatus === OrganisationOnboardingStatus.BLACKLISTED_ME) {
      message.error(
        'Forwarder is not accepting the booking on this rate. Inconvenience is deeply regretted.'
      );
      sendEvent(
        EventCategories.INQUIRY_BOOKING_SHIPPER,
        'Book Now - Failed (Blacklisted)',
        'Bid List View'
      );
      return;
    }
    if (
      connectionStatus === OrganisationOnboardingStatus.NON_LINKED ||
      connectionStatus === OrganisationOnboardingStatus.REJECTED_ME
    ) {
      this.setState({ isGeneratingBookingData: true });
      const response = await fetchKYC();
      if (!response.isSuccess) {
        message.error(response.errorMessage);
        this.setState({ isGeneratingBookingData: false });
      } else {
        this.setState({
          isFFConnectionRequestVisible: true,
          kycData: response.data?.kycData,
          kycExists: response.data?.kycExists,
          isGeneratingBookingData: false,
        });
      }
    } else {
      this.handleOpenCreateBookingModal();
    }
  };

  deadlineMissed = (deadline) => {
    const currentTime = moment();
    return currentTime.diff(moment(deadline), 'minutes') >= 0;
  };

  renderconfirmedStatus = () => {
    const { permissions: {INQUIRY_CONFIRM_DECLINE_ACTIONS}, classes, inquiryData } = this.props;
    return (
      <div className={classes.confirmBookButtons}>
        <div>
          <div style={{ fontSize: `${tokens.fontSize.body}px`, margin: '12px 0px 0px 0px', position: 'relative' }}>
            <Icon
              type="check-circle"
              theme="filled"
              style={{ color: '#44D13D', position: 'absolute', left: '-20px', bottom: '4px' }}
            />
            <span style={{ fontWeight: 600 }}>Confirmed Bid</span>
          </div>
          {INQUIRY_CONFIRM_DECLINE_ACTIONS && (
            <div>
              <a
                style={{ fontWeight: tokens.fontWeight.semibold, color: '#F5222D', fontSize: `${tokens.fontSize.small}px` }}
                onClick={this.showQuoteRejectionModal}
              >
                Decline Bid
              </a>
              <QuoteRejectionModal
                visible={this.state.rejectModalVisible}
                loading={this.state.isCardLoading}
                handleOk={this.toggleConfirm}
                handleCancel={this.quoteRejectModalHandleCancel}
                options={
                  this.deadlineMissed(inquiryData.deadline)
                    ? inquiryOptionsMap.reject
                    : undefined
                }
              />
            </div>
          )}
        </div>
        {this.renderBookNowButton()}
      </div>
    );
  };

  showDeleteConfirmationModal = () => {
    this.setState({
      deleteBidModalVisible: true,
      commentVisible: true,
    });
  }

  DeleteBidModalHandleCancel = () => {
    this.setState({
      deleteBidModalVisible: false,
      commentVisible: false,
    });
  };

  handleDeleteSuccessOkay = () => {
    this.setState({ deleteSuccess: false });
    this.props.applyFilter(this.props.inquiryData.id);
  };

  handleVehicleListExpand = () => {
    this.setState({
      isVehicleDetailsExpanded: !this.state.isVehicleDetailsExpanded,
    });
  };

renderDownloadTnCdocs = () => {
  const { cardData } = this.props;
  if (!cardData || !cardData.otherDetails || !cardData.otherDetails.termsAndConditions) return '';
  
  const { otherDetails, mode } = cardData;
  const { termsAndConditions } = otherDetails;
  const isAttachment = mode === InquiryModes.DOMESTIC || mode === InquiryModes.TRAILER || mode === InquiryModes.RPTL;
  const toolTipLabel = isAttachment ? 'Attachment' : 'Terms & Conditions';

  const handleViewDocument = (doc) => {
    this.setState({
      fileViewerVisible: true,
      selectedDocument: {
        url: doc.url,
        name: doc.name,
        type: doc.type || toolTipLabel
      }
    });
  };

  const handleDownloadDocument = (doc) => {
    const link = document.createElement('a');
    link.href = doc.url;
    link.download = doc.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Normalize to array format
  const documentsArray = Array.isArray(termsAndConditions) 
    ? termsAndConditions 
    : [{ url: termsAndConditions.url, name: termsAndConditions.name, type: toolTipLabel }];

  // Single document - show view and download buttons vertically
  if (documentsArray.length === 1) {
    const doc = documentsArray[0];
    
    return (
      <>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          gap: '2px',
          padding: '2px 0'
        }}>
          <Tooltip title={`View ${doc.name}`}>
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
              onClick={() => handleViewDocument(doc)}
            >
              <Icon type="eye" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Tooltip>
          
          <Tooltip title={`Download ${doc.name}`}>
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
              onClick={(event) => handleDownloadDocument(doc)}
            >
              <Icon type="download" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Tooltip>
        </div>
        
        {/* FileViewer for single document */}
        {this.state.fileViewerVisible && this.state.selectedDocument && (
          <FileViewer
            url={this.state.selectedDocument.url}
            title={this.state.selectedDocument.name}
            fileName={this.state.selectedDocument.name}
            onClose={() => this.setState({ fileViewerVisible: false, selectedDocument: null })}
          />
        )}
        <br />
      </>
    );
  }

  // Multiple documents - show view and download buttons vertically with menus
  const viewMenuItems = documentsArray.map((doc, index) => (
    <Menu.Item key={`view-${index}`} onClick={() => handleViewDocument(doc)}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        maxWidth: '200px'
      }}>
        <Icon type="eye" style={{ 
          marginRight: '8px',
          fontSize: `${tokens.fontSize.small}px`,
          color: 'inherit',
          flexShrink: 0
        }} />
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: `${tokens.fontSize.small}px`
          }}
          title={`${doc.type} - ${doc.name}`}
        >
          {`${doc.type} - ${doc.name}`}
        </span>
      </div>
    </Menu.Item>
  ));

  const downloadMenuItems = documentsArray.map((doc, index) => (
    <Menu.Item key={`download-${index}`} onClick={(event) => handleDownloadDocument(doc)}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        maxWidth: '200px'
      }}>
        <Icon type="download" style={{ 
          marginRight: '8px',
          fontSize: `${tokens.fontSize.small}px`,
          color: 'inherit',
          flexShrink: 0
        }} />
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: `${tokens.fontSize.small}px`
          }}
          title={`${doc.type} - ${doc.name}`}
        >
          {`${doc.type} - ${doc.name}`}
        </span>
      </div>
    </Menu.Item>
  ));

  return (
    <>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2px',
        padding: '2px 0'
      }}>
        <Tooltip title="View documents">
          <Dropdown
            overlay={<Menu>{viewMenuItems}</Menu>}
            trigger={['click']}
            placement="bottomLeft"
          >
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
            >
              <Icon type="eye" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Dropdown>
        </Tooltip>

        <Tooltip title="Download documents">
          <Dropdown
            overlay={<Menu>{downloadMenuItems}</Menu>}
            trigger={['click']}
            placement="bottomLeft"
          >
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px',
              }}
            >
              <Icon type="download" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Dropdown>
        </Tooltip>
      </div>
      
      {/* FileViewer for multiple documents */}
      {this.state.fileViewerVisible && this.state.selectedDocument && (
        <FileViewer
          url={this.state.selectedDocument.url}
          title={this.state.selectedDocument.name}
          fileName={this.state.selectedDocument.name}
          onClose={() => this.setState({ fileViewerVisible: false, selectedDocument: null })}
        />
      )}
      <br />
    </>
  );
};

  renderCol1 = () => {
    const { cardData, classes, inquiryData, vendorRatings } = this.props;
    const { isConfirmationRequiredForNegotiatedBid } = cardData;
    const ratingLabel = cardData?.ffRating ? vendorRatings[cardData?.ffRating - 1] : '';
    const origin = ` ${cardData.origin?.name ?? ''} (${cardData.origin?.code ?? ''})`;
    const destination = ` ${cardData.destination?.name ?? ''} (${cardData.destination?.code ?? ''})`;
    return (
      <Col span={4}>
        <div className={classes.ffOrgName}>
          <Tooltip title={cardData.ffName} mouseEnterDelay={0.5} placement="topLeft">
            {cardData.ffName}
          </Tooltip>
          <Tooltip title={ratingLabel}>
            <FieldRate
              isView={true}
              disabled={true}
              tooltips={[]}
              value={cardData?.ffRating}
              ratingViewLabel={ratingLabel}
              isFlex={true}
              styles={{fontSize: `${tokens.fontSize.caption}px`}}
              labelStyles={{fontWeight: 500, fontSize: `${tokens.fontSize.caption}px`, fontStyle: 'italic'}}
            />
          </Tooltip>
        </div>
        <div style={{ marginTop: '8px' }}>
          <img src={cardData.carrierLogoUrl} style={{ maxHeight: '40px', maxWidth: '70%' }} />
        </div>
        {!isConfirmationRequiredForNegotiatedBid && (
          <div style={{ fontSize: `${tokens.fontSize.h3}px`, color: '#262626', margin: '16px 0px 0px' }}>
            Rank: {cardData.rank}{' '}
            {cardData.isConfirmed && inquiryData.reasonForNonL1BidConfirmation && (
              <Tooltip
                title={
                  <div>
                    <p style={{ fontSize: tokens.fontSize.caption, marginBottom: 4 }}>
                      Remarks for choosing rank {cardData.rank}
                    </p>
                    <p style={{ fontSize: 11, margin: 0 }}>
                      {inquiryData.reasonForNonL1BidConfirmation}
                    </p>
                  </div>
                }
              >
                <Icon type="info-circle" theme="filled" style={{ color: '#000' }} />
              </Tooltip>
            )}
          </div>
        )}
        {/* render pol if allowVendorToSpecifyOrigin is true */}
        {inquiryData.otherDetails?.allowVendorToSpecifyOrigin && (
          <div>
            Origin:
            <span>{origin}</span>
          </div>
        )}
        {/* render pod if allowVendorToSpecifyDestination is true */}
        {inquiryData.otherDetails?.allowVendorToSpecifyDestination && (
          <div>
            Destination:
            <span>{destination}</span>
          </div>
        )}
      </Col>
    );
  };

  renderCol2 = () => {
    const { classes, cardData, currency } = this.props;
    if (!cardData) return '';
    const { otherDetails } = cardData;
    if (cardData.mode === InquiryModes.DOMESTIC || cardData.mode === InquiryModes.RPTL) {
      return this.renderDomesticCol2();
    }
    return (
      <Col span={7}>
        <div>
          {otherDetails?.originFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Origin Free Days
              <span className={classes.info}>{otherDetails?.originFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.demurrageFreeDays &&  (
            <div className={classes.cardHeaderItemsStyle}>
              Demurrage Free Days
              <span className={classes.info}>{otherDetails?.demurrageFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.detentionFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Detention Free Days
              <span className={classes.info}>{otherDetails?.detentionFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.cfsFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              CFS Free Days
              <span className={classes.info}>{otherDetails?.cfsFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.combinedFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Combined Free Days
              <span className={classes.info}>{otherDetails?.combinedFreeDays ?? '-'}</span>
            </div>
          )}
          {cardData.mode === InquiryModes.TRAILER && (
            <div className={classes.cardHeaderItemsStyle}>
              Detention Cost Per Day
              <span className={classes.info}>
                {isValidNumber(otherDetails?.detentionCostPerDay?.amount)
                  ? `${currency[`${otherDetails?.detentionCostPerDay?.currency}`]}${
                      otherDetails?.detentionCostPerDay?.amount
                    }`
                  : '-'}
              </span>
            </div>
          )}
          <div className={classes.cardHeaderItemsStyle}>
            Route
            <Tooltip
              title={
                otherDetails.route?.length > 1
                  ? otherDetails.route
                      ?.map((item) => BID_ROUTES_CARD_LABELS[item] || item)
                      .join(', ')
                  : ''
              }
            >
              <span className={classNames(classes.info, classes.ellipsis)}>
                {otherDetails.route
                  ?.map((item) => BID_ROUTES_CARD_LABELS[item] || item)
                  .join(', ') || '-'}
              </span>
            </Tooltip>
          </div>
          {otherDetails.transshipmentVia && (
            <div className={classes.cardHeaderItemsStyle}>
              Transshipment
              <span className={classes.info}>
                {otherDetails.transshipmentVia?.length > 0 ? (
                  <Tooltip
                    title={
                      otherDetails.transshipmentVia.length > 1
                        ? otherDetails.transshipmentVia.map((item) => <div>{item.label}</div>)
                        : ''
                    }
                  >
                    <span>
                      {otherDetails.transshipmentVia[0].label}
                      {otherDetails.transshipmentVia.length <= 1
                        ? ''
                        : ` + ${otherDetails.transshipmentVia?.length - 1}`}
                    </span>
                  </Tooltip>
                ) : (
                  '-'
                )}
              </span>
            </div>
          )}
          <div className={classes.cardHeaderItemsStyle}>
            Valid Till
            <span className={classes.info}>
              {moment(cardData.validTill).format('D MMM YYYY')}
            </span>
          </div>
        </div>
      </Col>
    );
  };

  renderCol3 = () => {
    const { classes, cardData } = this.props;
    const { otherDetails } = cardData;
    const alternateVesselSchedule = cardData?.otherDetails?.alternateVesselSchedule || '-';
    const truncatedText = alternateVesselSchedule.length > 10 ? `${alternateVesselSchedule.slice(0, 10)}...` : alternateVesselSchedule || '-';
    if (cardData.mode === InquiryModes.DOMESTIC || cardData.mode === InquiryModes.RPTL) {
      return this.renderDomesticCol3();
    }
    return (
      <Col span={7}>
        <div>
          {(
            <div className={classes.cardHeaderItemsStyle}>
              SI Cut Off{' '}
              <span className={classes.info}>
                {cardData?.otherDetails?.siCutOff ? getDateValue(formatDateFromObject(cardData?.otherDetails?.siCutOff))?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {cardData?.otherDetails?.etd && (
            <div className={classes.cardHeaderItemsStyle}>
              ETD{' '}
              <Tooltip
                title={
                  cardData.mode === InquiryModes.AIRCARGO
                    ? 'Flight Date'
                    : cardData.mode === InquiryModes.DOMESTIC
                    ? 'Departure Date'
                    : 'Sailing Date'
                }
              >
                <Icon type="exclamation-circle" theme="filled" />
              </Tooltip>
              <span className={classes.info}>
                {cardData?.otherDetails?.etd ? getDateValue(cardData?.otherDetails?.etd)?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {(
            <div className={classes.cardHeaderItemsStyle}>
              ETA{' '}
              <span className={classes.info}>
                {cardData?.otherDetails?.eta ? getDateValue(formatDateFromObject(cardData?.otherDetails?.eta))?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {cardData.mode !== InquiryModes.TRAILER && (
            <div className={classes.cardHeaderItemsStyle}>
              Transit Days
              <span
                className={classes.info}
                style={{ width: cardData.mode === 'LCL' ? '68%' : '48%' }}
              >
                {otherDetails?.transitDays ?? '-'}
              </span>
            </div>
          )}
          {cardData.mode === InquiryModes.TRAILER ? (
            <div className={classes.cardHeaderItemsStyle}>
              Round Trip Time
              <span className={classes.info}>
                {isValidNumber(cardData.otherDetails?.roundTripTime?.value)
                  ? `${cardData.otherDetails?.roundTripTime?.value} ${cardData.otherDetails?.roundTripTime?.type}`
                  : '-'}
              </span>
            </div>
          ) : (
            <React.Fragment>
              <div className={classes.cardHeaderItemsStyle}>
                Schedule
                <span className={classes.info}>
                  {cardData &&
                  cardData.otherDetails &&
                  cardData.otherDetails.schedule &&
                  cardData.otherDetails.schedule.length > 0
                    ? cardData.otherDetails.schedule.map((item) => `${item[0].toUpperCase()} `)
                    : '-'}
                </span>
              </div>
            </React.Fragment>
          )}
          {(
          <div className={classes.cardHeaderItemsStyle} title={alternateVesselSchedule}>
            Alternate Vessel Schedule{' '}
            <span className={classes.info}>
              {truncatedText}
            </span>
          </div>
        )}
        {(
          <div className={classes.cardHeaderItemsStyle}>
            Allowed Cargo Weight (Kg) {' '}
            <span className={classes.info}>
              {cardData?.otherDetails?.allowedCargoWeight || '-'}
            </span>
          </div>
        )}
        </div>  
      </Col>
    );
  };

  renderCol4 = () => {
    const { classes, cardData, currency, permissions, inquiryData, userCurrency, exchangeRateDate } = this.props;
    const currentTimeMilisec = new Date().getTime();
    if (!cardData) return '';
    const totalAmount = cardData?.exchangeRateDate ? cardData?.userTotalWithoutTax?.amount : cardData?.shipperTotalWithoutTax?.amount;
    const totalCurrency = cardData?.exchangeRateDate ? cardData?.userTotalWithoutTax?.currency : cardData?.shipperTotalWithoutTax?.currency;
    return (
      <div className="ant-col ant-col-6">
        <Row>
          <Col span={20}>
            <div style={{ marginLeft: '10px' }}>
              <span style={{ fontSize: 14 }}>Total Price &nbsp;&nbsp;</span>
              {/* {inquiryData?.mode === InquiryModes.DOMESTIC ? ( */}
              <span style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.text }}>
                <span style={{ fontSize: 14 }}>
                  {getBidTotal(totalAmount)}{' '}
                </span>
                <span style={{ fontSize: `${tokens.fontSize.small}px`}}>
                  &nbsp;{totalCurrency}
                </span>
              </span>
              {/* ) : (
                <PricePerContainer
                  amount={cardData.totalPerUnit && cardData.totalPerUnit.amount}
                  currency={cardData.totalPerUnit && cardData.totalPerUnit.currency}
                  perLabel={cardData.totalPerUnit && cardData.totalPerUnit.format}
                  containerTypes={cardData.totalPerUnitType}
                  containerDetails={cardData.containerDetails || cardData.inquiryContainerDetails}
                  mode={cardData.mode}
                  totalPrice={cardData.shipperTotalWithoutTax}
                  sourceObjectType={'BID'}
                />
              )} */}
              {/*<PriceTotal
                amount={cardData.shipperTotalWithoutTax.amount}
                currencySymbol={this.props.currency
                [`${cardData.shipperTotalWithoutTax.currency}`]}/>*/}
              {![InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL].includes(cardData.mode) ? (
                <FrieghtPerUnit
                  amount={cardData.freightPerUnit && cardData.freightPerUnit.amount}
                  currency={cardData.freightPerUnit && cardData.freightPerUnit.currency}
                  perLabel={cardData.freightPerUnit && cardData.freightPerUnit.format}
                  label={'Avg Freight'}
                />
              ) : (InquiryModes.DOMESTIC === cardData.mode || InquiryModes.RPTL === cardData.mode) ? (
                ''
              ) : (
                renderTotalPrice(cardData.shipperTotalWithoutTax, currency)
              )}
              <div className={classes.viewBreakdownStyle}>
                <a className={classes.viewBreakdownStyle} onClick={this.handleViewBreakDown}>
                  View Breakdown
                </a>
              </div>
              {this.state.viewBreakDownVisible && (
                <ViewBreakdown
                  mode={inquiryData?.mode}
                  type={'SHIPPER'}
                  visible={this.state.viewBreakDownVisible}
                  bidId={cardData.id}
                  inquiryId={inquiryData.id}
                  handleCancel={this.closeViewBreakdown}
                  handleOk={this.handleOkViewBreakDown}
                />
              )}
              {cardData.isConfirmed ? this.renderconfirmedStatus() : this.renderButton()}
              <QuoteConfirmationModal
                visible={this.state.confirmModalVisible}
                inquiryData={inquiryData}
                bidData={cardData}
                topBidData={this.props.topBidData}
                captureReasonForNonL1Bid={this.props.captureReasonForNonL1Bid}
                isLoading={this.state.isCardLoading}
                handleOk={this.toggleConfirm}
                loading={this.state.isCardLoading}
                handleCancel={this.quoteConfirmModalHandleCancel}
                options={
                  inquiryData.deadline - currentTimeMilisec > 0
                    ? inquiryOptionsMap.confirm
                    : undefined
                }
              />
            </div>
          </Col>
          {this.renderCol5()}
        </Row>
      </div>
    );
  };

  renderCol5 = () => {
    const { classes, cardData, inquiryData, permissions: {INQUIRY_CONFIRM_DECLINE_ACTIONS} } = this.props;
    return (
      <Col span={4} className={classes.iconToolbar}>
        {(this.props.showInquiryComments && !this.props.isParentOrg) && (
          <CommentCount
          prefetchedCount={cardData.commentCount}
            isLoading={this.props.isLoading}
            commentApiPrefix={'inquiry/bid'}
            sourceObjectId={cardData.baseRevisionBidId}
            modalHeader={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    color: '#262626',
                    alignSelf: 'center',
                    fontSize: `${tokens.fontSize.h2}px`,
                    fontWeight: tokens.fontWeight.semibold,
                    marginLeft: '15px',
                  }}
                >
                  {cardData.ffName}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginRight: '12px',
                  }}
                >
                  <div style={{ marginTop: '8px', marginRight: '68px' }}>
                    <img src={cardData.carrierLogoUrl} />
                  </div>
                  <div>
                    <PriceTotal
                      commentTextStyle={true}
                      amount={cardData?.exchangeRateDate ? cardData.userTotalWithoutTax.amount : cardData.shipperTotalWithoutTax.amount}
                      currencySymbol={
                        cardData?.exchangeRateDate ? cardData.userTotalWithoutTax.currency : cardData.shipperTotalWithoutTax.currency
                      }
                      source={'INQUIRY'}
                    />
                    <PricePerContainer
                      commentTextStyle={true}
                      amount={cardData.totalPerUnit && cardData.totalPerUnit.amount}
                      currency={cardData.totalPerUnit && cardData.totalPerUnit.currency}
                      perLabel={cardData.totalPerUnit && cardData.totalPerUnit.format}
                      containerTypes={cardData.totalPerUnitType}
                      mode={cardData.mode}
                      totalPrice={cardData?.exchangeRateDate ? cardData.userTotalWithoutTax : cardData.shipperTotalWithoutTax}
                      sourceObjectType={'BID'}
                    />
                  </div>
                </div>
              </div>
            }
          />
        )}
        {!cardData.isDeletedByShipper && !cardData.isConfirmed && INQUIRY_CONFIRM_DECLINE_ACTIONS ? (
          <div>
            <Icon
              type="delete"
              style={{ fontSize: `${tokens.fontSize.h2}px`, cursor: 'pointer' }}
              onClick={() => this.showDeleteConfirmationModal()}
            />

            <DeleteBidConfirmationModal
              visible={this.state.deleteBidModalVisible}
              ffName={cardData.ffName}
              handleOk={this.state.commentVisible ? this.handleCommentSubmit : this.handleDeleteBid}
              handleCancel={this.DeleteBidModalHandleCancel}
              commentVisible={this.state.commentVisible}
              onChangeReason={this.handleOnChangeReason}
              value={this.state.deletionReason}
              loading={this.state.isCardLoading}
            />
            <DeleteBidSuccessModal
              visible={this.state.deleteSuccess}
              ffName={cardData.ffName}
              referenceNumber={inquiryData.referenceNumber}
              handleOk={this.handleDeleteSuccessOkay}
            />
          </div>
        ) : null}
        {this.renderDownloadTnCdocs()}
      </Col>
    );
  };

  renderModal = () => {
    const { cardData, inquiryData } = this.props;
    const { revisionModalVisible } = this.state;

    return (
      revisionModalVisible && (
        <BidRevisionModal
          visible={revisionModalVisible}
          handleCancel={() => {
            this.setState({
              revisionModalVisible: false,
            });
          }}
          title="Revision History"
          okText="Okay"
          handleOk={() => {
            this.setState({
              revisionModalVisible: false,
            });
          }}
          userType="SHIPPER"
          inquiryDetails={inquiryData}
          baseRevisionBidId={cardData.baseRevisionBidId}
          cancelButtonVisible={false}
        />
      )
    );
  };

  showVersionHistory = () => {
    this.setState({
      revisionModalVisible: true,
    });
  };

  renderConfirmationReason = () => {
    const { cardData, classes } = this.props;
    const { rank, isConfirmed, nonL1ConfirmationReason } = cardData;
    
    // Only show if rank is not 1, bid is confirmed, and reason exists
    if (Number(rank) === 1 || !isConfirmed || !nonL1ConfirmationReason) {
      return null;
    }

    return (
      <Tooltip title={nonL1ConfirmationReason} placement="top">
        <Button
          size="small"
          type="dashed"
          className={classes.confirmationReasonButton}
          aria-label={`Confirmation Reason: ${nonL1ConfirmationReason}`}
        >
          <Icon type="check-circle" theme="filled" className={classes.confirmationReasonIcon} />
          <span className={classes.confirmationReasonText}>
            <strong>Confirmation Reason: </strong>{nonL1ConfirmationReason}
          </span>
        </Button>
      </Tooltip>
    );
  };

  renderVersion = () => {
    const { cardData, classes } = this.props;
    return (
      <div className={classes.renderVersionContainer}>
        {cardData.revisionNumber > 0 && (
          <div>
            <Tag color="cyan">Revised Bid</Tag>
            <span className={classes.versionHistoryButton} onClick={this.showVersionHistory}>
              Version History
            </span>
            {this.renderModal()}
          </div>
        )}
      </div>
    );
  };

  renderStatus = () => {
    const { classes } = this.props;
    return <div className={classes.connectionStatus}>{connectionRequestMessage}</div>;
  };

  renderDomesticCol2 = () => {
    const { cardData, classes, domesticVehicleTypeSizeList } = this.props;
    const { isVehicleDetailsExpanded } = this.state;
    return (
      <Col span={7}>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Vehicle Details
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getTrailerOrDomesticVehicleList(
              cardData,
              domesticVehicleTypeSizeList,
              isVehicleDetailsExpanded,
              this.handleVehicleListExpand,
              true
            )}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Weekly Schedule
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {['S', 'M', 'T', 'W', 'Th', 'F', 'Sa'].map((day) => {
              const isValid = cardData?.otherDetails?.schedule?.includes(day?.toLowerCase());
              return (
                <span
                  style={{
                    fontWeight: tokens.fontWeight.semibold,
                    color: isValid ? tokens.colors.text : '#CCCCCC',
                    marginRight: '8px',
                    fontSize: `${tokens.fontSize.small}px`,
                  }}
                >
                  {day}
                </span>
              );
            })}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            ETD
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDateValue(cardData?.otherDetails?.etd)?.format('DD MMM YYYY') || '-'}
          </Col>
        </Row>
      </Col>
    );
  };

  renderDomesticCol3 = () => {
    const { cardData, classes, currency } = this.props;
    const { freightCharges, originCharges, destinationCharges } = cardData?.chargeDetails;
    const isExchangeDatePresent = cardData?.exchangeRateDate;
    return (
      <Col span={7}>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Transport Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(freightCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Origin Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(originCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Destination Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(destinationCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Bid Valid Till
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {moment(cardData?.validTill).format('D MMM YYYY')}
          </Col>
        </Row>
      </Col>
    );
  };

  handleCloseCreateBookingModal = (bookingNumber = undefined, bookingId = undefined) => {
    sendEvent(EventCategories.INQUIRY_BOOKING_SHIPPER, 'Book Now - Cancelled', 'Bid List View');
    this.setState({
      bookingId,
      bookingNumber,
      createInquiryModalVisible: false,
      protipVisible: bookingNumber ? true : false,
      isFFConnectionRequestVisible: false,
    });
  };

  handleProtipClose = () => {
    this.setState({
      protipVisible: false,
    });
    this.props.history.push(bookingShipperRoute());
  };

  render() {
    const { classes, cardData, inquiryData } = this.props;
    const {
      createInquiryModalVisible,
      protipVisible,
      bookingId,
      isFFConnectionRequestVisible,
      kycExists,
      isGeneratingBookingData,
      kycData,
      isBookingTnCModalVisible,
      bookingNumber,
      isAdditionalEmailsModalVisible,
    } = this.state;
    const { isConfirmationRequiredForNegotiatedBid } = cardData;
    const ffOrganisation = {
      id: cardData.ffId,
      name: cardData.ffName,
    };
    return (
      <div className={classes.parentDiv} style={{ margin: '0 12px 8px 12px' }}>
        <div style={cardData.isDeletedByShipper ? { opacity: 0.6 } : undefined}>
          <Row
            style={{
              pointerEvents: isConfirmationRequiredForNegotiatedBid ? 'none' : 'unset',
              opacity: isConfirmationRequiredForNegotiatedBid ? 0.3 : 1,
            }}
          >
            {this.renderCol1()}
            {this.renderCol2()}
            {this.renderCol3()}
            {this.renderCol4()}
          </Row>
          <Row>
            <div className={classes.btmRowContainer}>
              <div className={classes.btmRowLeftSection}>
                {this.renderConfirmationReason()}
                {this.renderVersion()}
              </div>
              {isConfirmationRequiredForNegotiatedBid ? (
                this.renderStatus()
              ) : (
                <div className={classes.updatedTimeContainer}>{this.renderUpdatedTime()}</div>
              )}
            </div>
          </Row>
        </div>
        {createInquiryModalVisible && (
          <CreateInquiryModal
            handleCancel={this.handleCloseCreateBookingModal}
            clickedFrom="Bid List View"
            visible={createInquiryModalVisible}
            data={inquiryData}
            bidData={cardData}
          />
        )}
        {protipVisible && (
          <BookingSuccessProtip
            bookingId={bookingNumber}
            visible={protipVisible}
            handleClose={this.handleProtipClose}
            handleNotifyUsers={() => {
              this.setState({
                protipVisible: false,
                isAdditionalEmailsModalVisible: true,
              });
            }}
          />
        )}
        {isFFConnectionRequestVisible && (
          <FFConnectionRequestKYC
            isVisible={isFFConnectionRequestVisible}
            ffOrganisation={ffOrganisation}
            firstTime={!kycExists}
            kycData={kycData}
            isGeneratingBookingData={isGeneratingBookingData}
            createBooking={this.handleOpenCreateBookingModal}
            onCancel={() => this.setState({ isFFConnectionRequestVisible: false })}
          />
        )}
        {isBookingTnCModalVisible && this.renderBookingTncModal()}
        {this.state.isExistingBookingAlertVisible && this.renderExistingBookingAlertModal()}
        {isAdditionalEmailsModalVisible && (
          <AdditionalEmailsForBookingModal
            isVisible={isAdditionalEmailsModalVisible}
            handleCancel={() => {
              this.setState({ isAdditionalEmailsModalVisible: false, protipVisible: true });
            }}
            bookingId={bookingId}
            handleSuccess={() => {
              this.setState({ isAdditionalEmailsModalVisible: false });
              this.props.history.push(bookingShipperRoute(), {
                successMessage: 'Booking updates have been sent successfully to users!',
              });
            }}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = ({ masterData }) => ({
  currency: masterData.currencySymbols,
  permissions: masterData.permissions,
  showInquiryComments: masterData.modules.show_inquiry_comments,
  domesticVehicleTypeSizeList: masterData.domesticVehicleTypeSizeList,
  userCurrency: masterData?.userData?.user_metadata?.user_currency,
  vendorRatings: Object.values(masterData?.vendorRating?.mapping || {}),
  isParentOrg: masterData.isParentOrg
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetFilters,
      applyFilter,
    },
    dispatch
  );
const ShipperBidCardStyled = injectSheet(styles)(Form.create()(ShipperBidCard));
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShipperBidCardStyled));
